import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";


const Frmforgotten = () => {
  
  const history = useHistory();
  
  const [showPassword, setShowPassword] = useState(false);
  
  const [email, setEmail] = useState("");  
  const [token, settoken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {      
      const res = await axios.post("/forgotten", { email });
      setMessage(res.data.message);
    } catch (error) {
      setMessage("Error sending email. Please try again.");
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();
    try {      
      if(confirmPassword === password){        
        const res = await axios.post("/resetpassword", { token, password});
        if(res.data.message === 'ok'){
          history.push('/login');
        }
        if(res.data.message === 'Token ID is expired!'){
          alert('Token ID is expired!');
        }

        
      }
      else{
        alert('Please check password = confirmPassword?')
      }
     
    } catch (error) {
        alert("Error change password! Please try again.");
    }
  };



    return (  
      <>    
        <div className="container text-center mt-5">
          <form onSubmit={handleSubmit}>
            <h2 className="text-primary">Forgotten Password</h2>
            <p>Please enter your email to reset your password.</p>
            <input type="email" className="form-control w-50 mx-auto" placeholder="Enter your email"  onChange={(e) => setEmail(e.target.value)} required  />
            <button className="btn btn-primary mt-3">Submit</button>
          </form><br></br>
          {message && <p>{message}</p>}
        </div>
        
        <div className="container text-center col-md-4">          
          {message && 
          <form name='frmreset' id='frmreset' onSubmit={handleSubmit2}>
            <div className="input-group mb-2">             
                <input                   
                  type={showPassword ? "text" : "password"}
                  className="form-control w-50 mx-auto"
                  placeholder="Your Token" 
                  value={token}    
                  onChange={(e) => settoken(e.target.value)}            
                  required 
                /> 
                  <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        >
                        <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                  </button>
            </div>
            <div className="input-group mb-2">             
              <input 
              //type="password"
              type={showPassword ? "text" : "password"} 
              className="form-control w-50 mx-auto"
              placeholder="New Password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            /> 
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            
            </div>
            
            <div className="input-group mb-2">             
              <input 
                //type="password" 
                type={showPassword ? "text" : "password"} 
                className="form-control w-50 mx-auto"
                placeholder="Confirm Password" 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                required 
              />  
              <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  >
                  <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                </button>
            </div>          
            
            <button className="btn btn-primary mt-3" type="submit">Change Password</button>
          
          </form> }

        </div>
      </>
      );
}

export default Frmforgotten